import type { BatchPageRow } from "@/types";

/**
 * The Batch Test page the Matrix is showing — what Batch Test labels
 * `Matrix 표시 중` (artifact `shownPage`).
 *
 * Test Result records the page it resolved, whether the URL named it or it
 * fell back to the default. Before Test Result has been opened, the default
 * it would pick stands in: the newest page that has run.
 *
 * Module memory like `lastSearch` — a reload forgets it.
 */

let shown: string | null = null;

export function rememberShownPage(pageId: string | null): void {
  shown = pageId;
}

/** `rows` newest first, as the list returns them. */
export function shownPageId(rows: readonly BatchPageRow[] | null): string | null {
  if (shown) return shown;
  return rows?.find((row) => row.run_count > 0)?.page_id ?? null;
}

/** For tests. */
export function forgetShownPage(): void {
  shown = null;
}
